import { render } from "./edit-schedule-model.vue?vue&type=template&id=4ddfcc33"
import script from "./edit-schedule-model.vue?vue&type=script&lang=js"
export * from "./edit-schedule-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__